import { render, staticRenderFns } from "./DiagramLegendTable.vue?vue&type=template&id=4817183e&scoped=true&"
import script from "./DiagramLegendTable.vue?vue&type=script&lang=ts&"
export * from "./DiagramLegendTable.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramLegendTable.vue?vue&type=style&index=0&id=4817183e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817183e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
